export const GENERIC_ERROR_MESSAGE = 'Oops! We ran into some issues. Please try again later.';

export const getGenericErrorMessage = (reason) => {
    return `Oops, ${reason}. Try again in a bit.`;
};
